//API List
//Cashier APIs
export const CASHIER_API_01 = "Placedorders";
export const CASHIER_API_02 = "Placedorderdetails";
export const CASHIER_API_03 = "Placeorder";
export const CASHIER_API_04 = "Cashbalance";
export const CASHIER_API_05 = "Cashbalancetypes";
export const CASHIER_API_06 = "Placedordersummery";
export const PARAMETER_API_01 = "Parameters";

//Customer APIs
export const CUSTOMER_API_01 = "Supplier";
export const CUSTOMER_API_02 = "Customers";
export const Country_API_02 = "Country";
export const Guesttype_01 = "Guesttype";
export const Unit_01 = "Units";
export const images_01 = "Itemimages";

//Employee APIs
export const EMPLOYEE_API_01 = "Usergroup";
export const EMPLOYEE_API_02 = "Useraccess";
export const EMPLOYEE_API_03 = "Userpwd";
export const EMPLOYEE_API_04 = "Userprofile";
export const EMPLOYEE_API_05 = "Mapuser";
export const EMPLOYEE_API_06 = "Useraccount";

//Guest APIs
export const GUEST_API_01 = "Guestorder";
export const GUEST_API_02 = "Guestorderdetails";
export const GUEST_API_03 = "Guestorderlist";
export const GUEST_API_04 = "Guestorders";
export const GUEST_API_05 = "Guestpromotions";
export const GUEST_API_06 = "Guesttype";
export const GUEST_API_07 = "Store";
export const AGENT_API_01 = "Agents";

export const Approveorder_API_01 = "Approveorder";
//Kitchen APIs
export const KITCHEN_API_01 = "Kitchenorders";
export const KITCHEN_API_02 = "Kitchesummery";

//Order APIs
export const ORDER_API_01 = "Chefforder";
export const ORDER_API_02 = "Chefforderupdate";
export const ORDER_API_03 = "Orderlist";
export const ORDER_API_04 = "Orderreturn";
export const ORDER_API_05 = "Orderplace";
export const ORDER_API_06 = "Bill";
export const ORDER_API_07 = "Orderconfirm";
export const ORDER_API_08 = "Cancelorder";
export const ORDER_API_09 = "Ordercalculation";
export const ORDER_API_10 = "Validategiftvoucher";
export const ORDER_API_11 = "Customerloyalty";
export const ORDER_API_12 = "Orderdetailsforapproval";
export const ORDER_API_13 = "Approveagentorder";
export const ORDER_API_14 = "Orderreturnlist";
export const ORDER_API_15 = "Orderreturndetail";
export const ORDER_API_16 = "Notelist";
export const ORDER_API_17 = "Refundnote";
export const ORDER_API_18 = "Orderrefund";
export const ORDER_API_19 = "orderreturn/cancelorderreturn";
//Promotions APIs
const PROMOTIONS_API_01 = "";

//Settings APIs
export const SETTINGS_API_01 = "Mapbilloption";
export const SETTINGS_API_02 = "Category";
export const SETTINGS_API_03 = "Items";
export const SETTINGS_API_04 = "Ordertracking";
export const SETTINGS_API_05 = "Tables";
export const SETTINGS_API_06 = "Waiters";
export const SETTINGS_API_07 = "Addon";
export const SETTINGS_API_08 = "Mapprinters";
export const SETTINGS_API_09 = "Receiptdetails";
export const SETTINGS_API_10 = "Ordertracking";
export const SETTINGS_API_19 = "Othercharges";
export const SETTINGS_API_20 = "Billoption";
export const SETTINGS_API_22 = "Ordertypes";
export const SETTINGS_API_23 = "Barcode";
export const SETTINGS_API_24 = "Mapbilloption";
export const SETTINGS_API_25 = "Orderstatus";
export const SETTINGS_API_26 = "Measuringunit";
export const SETTINGS_API_27 = "Mou";

export const ORDERTRACKING_API_1 = "Ordertrackinginfo";
export const Schedule_API_1 = "Schedule";

// Login API (Post API)
export const LOGIN_API = "login/login";
export const LOGOUT_API = "Login/Logout";
export const LOGIN_API_2 = "Login/Transferlogin";

//Stock APIs
export const STOCK_API_01 = "Stock";
export const STOCK_API_02 = "Stockdetails";
export const STOCK_API_03 = "Stockbalance";
//COUSTOMER API

export const SETTINGS_API_11 = "Memberships";
export const SETTINGS_API_12 = "Customers";
export const SETTINGS_API_13 = "Supplier";
export const SETTINGS_API_14 = "Giftcertificate";

export const SETTINGS_API_15 = "Giftcertificatedetails";
export const SETTINGS_API_18 = "Giftvoucher";
export const SETTINGS_API_28 = "AllGiftvoucher";
//PROMOTION
export const SETTINGS_API_16 = "Promotionalmenu";
export const SETTINGS_API_17 = "Promotionalmenucategory";
export const SETTINGS_API_21 = "Promotions";

//reprot
export const REPORT_API_01 = "Reports";
export const REPORT_API_02 = "Generatereport";

//Common APIs
export const COMMON_API_01 = "Ordertypes";
export const COMMON_API_02 = "Allitems";
export const COMMON_API_03 = "Tables";
export const COMMON_API_04 = "Banks";
export const COMMON_API_05 = "Bankbranches";
export const COMMON_API_06 = "Rooms";
export const COMMON_API_07 = "Paymentoptions";
export const COMMON_API_08 = "Allitemswithpromo";
export const LOCATION_01 = "Mappedlocations";
export const REST_01 = "Mappedrestaurants";
export const Dayend_API_01 = "Dayend";

export const FILE_API_01 = "Fileupload/upload";

// export const MENUTYPECODE = "F";
export const CHAINCODE = "4";
export const BUSINESSTYPECODE = "R";
export const CERTIFICATECODE = "1";
export const MENUCATCODE = "7";

export const RECIPE_API_01 = "Recipemetadata";
export const RECIPE_API_02 = "Recipe";
export const RECIPE_API_03 = "Recipe/calculateitemcost";
export const RECIPE_API_04 = "Recipe/allrecipes";

export const InvCategory_01 = "Invproductcategory";
export const InvSubCategory_01 = "Invproductsubcategory";
export const InvProduct_01 = "Invproduct";

// export const ENUSER = "SIR";

// export const COMPCODE = "CP220000107";
// export const LOCCODE = "MRTMCLC0059";
// export const RESTCODE = "4";
// export const STS = "A";
